import angular from 'angular';
import { heightCalcModule } from '../../services/heightCalc/heightCalc.module';
import { horizontalTableModule } from '../HorizontalTable/HorizontalTable.module';
import { menuBarModule } from '../MenuBar/MenuBar.module';
import { scrollPaneModule } from '../ScrollPane/ScrollPane.module';
import { titleBarModule } from '../TitleBar/TitleBar.module';
import { WidgetController } from './Widget.controller';
import template from './Widget.template.html';

export const widgetModule = angular
  .module('bit.components.Widget', [
    horizontalTableModule.name,
    titleBarModule.name,
    menuBarModule.name,
    heightCalcModule.name,
    scrollPaneModule.name,
  ])
  .component('bitWidget', {
    template,
    controller: WidgetController,
  });
